import { observer } from "mobx-react-lite";
import { Toggle } from "@/components/ui/toggle";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { Waypoints } from "lucide-react";
import { cn } from "@/lib/utils";
import type { MapStore } from "@/components/Map/stores/MapStore";

interface ConnectionsControlsProps {
	mapStore: MapStore<any>;
}

export const ConnectionsControls = observer(({ mapStore }: ConnectionsControlsProps) => {
	const { connectionsStore } = mapStore;
	return (
		<div className="absolute left-[10px] bottom-[345px] z-10 inline-flex flex-col w-[30px] rounded-md bg-white shadow-[0_0_0_2px_#0000001a] overflow-hidden">
			<Tooltip>
				<TooltipTrigger asChild>
					<Toggle
						size="sm"
						pressed={connectionsStore.visible}
						onPressedChange={() => connectionsStore.toggle()}
						className={cn(
							"rounded-none bg-white hover:bg-white h-8 px-1.5 min-w-6",
							connectionsStore.visible ? "text-[#003BFF]" : "text-gray-300",
						)}
						aria-label="Toggle network connections"
					>
						<Waypoints className="h-4 w-4" />
					</Toggle>
				</TooltipTrigger>
				<TooltipContent side="right">Network connections</TooltipContent>
			</Tooltip>
		</div>
	);
});
